import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Format ABN with spaces (XX XXX XXX XXX)
 * @param abn - ABN string (11 digits)
 * @returns Formatted ABN with spaces or original if invalid
 */
export function formatABN(abn: string | null | undefined): string {
  if (!abn) return "";
  const digits = abn.replace(/\D/g, "");
  if (digits.length === 11) {
    return `${digits.slice(0, 2)} ${digits.slice(2, 5)} ${digits.slice(5, 8)} ${digits.slice(8, 11)}`;
  }
  return abn;
}

/**
 * Format ACN with spaces (XXX XXX XXX)
 * @param acn - ACN string (9 digits)
 * @returns Formatted ACN with spaces or original if invalid
 */
export function formatACN(acn: string | null | undefined): string {
  if (!acn) return "";
  const digits = acn.replace(/\D/g, "");
  if (digits.length === 9) {
    return `${digits.slice(0, 3)} ${digits.slice(3, 6)} ${digits.slice(6, 9)}`;
  }
  return acn;
}
